import Vue from 'vue'

export const OrderEvents = new Vue()
